import React, { useState, createContext, useContext } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { Gallery } from './components/Gallery';
import { ServiceAreas } from './components/ServiceAreas';
import { Guarantee } from './components/Guarantee';
import { Financing } from './components/Financing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { BookingModal } from './components/BookingModal';

// Global context so any component can open the modal
export const ModalContext = createContext<{
  openModal: () => void;
}>({
  openModal: () => {}
});
export function useModal() {
  return useContext(ModalContext);
}
export function App() {
  const [modalOpen, setModalOpen] = useState(false);
  return <ModalContext.Provider value={{
    openModal: () => setModalOpen(true)
  }} data-id="element-0">
      <div className="min-h-screen bg-background font-sans text-foreground selection:bg-amber-500/30" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <TrustBar data-id="element-5" />
          <Services data-id="element-6" />
          <HowItWorks data-id="element-7" />
          <WhyChooseUs data-id="element-8" />
          <Testimonials data-id="element-9" />
          <Gallery data-id="element-10" />
          <ServiceAreas data-id="element-11" />
          <Guarantee data-id="element-12" />
          <Financing data-id="element-13" />
          <FAQ data-id="element-14" />
        </main>
        <Footer data-id="element-15" />

        {/* Global booking modal — triggered by any CTA */}
        <BookingModal isOpen={modalOpen} onClose={() => setModalOpen(false)} data-id="element-16" />
      </div>
    </ModalContext.Provider>;
}